import HTTP from '@/api/HTTP';
import transformer from '@/services/ligneCommande/ligneCommandeServerTableDataTransformer';

const URL_BASE = 'gescom/LigneCommande/';

export async function getAll(serverTabledata) {
  const inputServer = transformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function updateDatePlanifieeInLignesCmd(param) {
  const response = await HTTP.put(URL_BASE + 'UpdateDatePlanifieeInLignesCmdAsync', param);
  return response;
}

export async function updateVerrouillageLigneCommande(param) {
  const response = await HTTP.put(URL_BASE + 'UpdateVerouillageLogistique', param);
  return response;
}

export async function updateLogistiquePresse(param) {
  const response = await HTTP.put(URL_BASE + 'UpdateLogistiquePresse', param);
  return response;
}

export async function updateLigneCommandePresseVisuelDemande(param) {
  const response = await HTTP.put(URL_BASE + 'UpdateLigneCommandePresseVisuelDemande', param);
  return response;
}

export async function getAllWithEcheancier(serverTabledata) {
  const inputServer = transformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAvecEcheanchierAsync', inputServer);
  return response;
}

export async function affichelivreAsync(payload) {
  const response = await HTTP.post(URL_BASE + 'AffichelivreAsync', payload);
  return response;
}
